import api from "~/services/apis/antecipeApi";

export const getMe = async () => {
  const response = await api.get("auth/me", { skipAuthRedirect: true });
  return response.data.data;
};

export const logoutSession = async () => {
  await api.post("auth/logout", {}, { skipAuthRedirect: true });
};

// Contexto da tela "Acesso não liberado" (spec §2.11, P1-6). Anônimo; o ref vale 15 min.
export const getDenial = async (ref) => {
  const response = await api.get(`auth/denial/${encodeURIComponent(ref)}`, { skipAuthRedirect: true });
  return response.data.data;
};

// Navegação de página inteira (o BE responde 302 para o Google). Nunca via XHR.
export const googleRedirectUrl = (invite) => {
  const base = process.env.REACT_APP_ANTECIPE_URL || "/api/v1/";
  const url = `${base}auth/google/redirect`;
  return invite ? `${url}?invite=${encodeURIComponent(invite)}` : url;
};
